// app/javascript/controllers/dynamic_roles_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "role"]
  static values = { type: String }

  addRole(event) {
    event.preventDefault()
    
    const template = this.roleTargets[0].cloneNode(true)
    const inputs = template.querySelectorAll('input, select')
    inputs.forEach(input => input.value = '')
    
    this.containerTarget.appendChild(template)
  }
}
